import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { confirmable } from 'react-confirm'

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modal: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '5px',
    textAlign: 'center',
    width: '300px',
  },
  inputBox: {
    width: '100%',
    padding: '10px',
    marginBottom: '20px',
    border: '1px solid #ccc',
    borderRadius: '5px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
  },
  button: {
    backgroundColor: '#e74c3c', // red for confirm button
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  buttonActive: {
    opacity: 1,
    pointerEvents: 'auto',
  },
  buttonHover: {
    backgroundColor: '#c0392b',
  },
  cancelButton: {
    backgroundColor: '#2c2c2c',
  },
  cancelButtonHover: {
    backgroundColor: '#000000',
  },
}

const CustomDialog = ({ show, proceed, confirmation, options }) => {
  const [inputValue, setInputValue] = useState('')

  const isDeleteConfirmed = inputValue === 'DELETE'

  return (
    <div style={{ ...styles.overlay, display: show ? 'flex' : 'none' }}>
      <div style={styles.modal}>
        <p style={{ marginBottom: '10px' }}>{confirmation}</p>
        <input
          type="text"
          placeholder="Type DELETE to confirm"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          style={styles.inputBox}
        />
        <div style={styles.buttonContainer}>
          <button
            style={{
              ...styles.button,
              ...(isDeleteConfirmed ? styles.buttonActive : { opacity: 0.5 }),
            }}
            onMouseEnter={(e) =>
              isDeleteConfirmed &&
              (e.target.style.backgroundColor =
                styles.buttonHover.backgroundColor)
            }
            onMouseLeave={(e) =>
              isDeleteConfirmed &&
              (e.target.style.backgroundColor = styles.button.backgroundColor)
            }
            onClick={() => proceed(true)}
            disabled={!isDeleteConfirmed}
          >
            Confirm
          </button>
          <button
            style={{ ...styles.button, ...styles.cancelButton }}
            onMouseEnter={(e) =>
              (e.target.style.backgroundColor =
                styles.cancelButtonHover.backgroundColor)
            }
            onMouseLeave={(e) =>
              (e.target.style.backgroundColor =
                styles.cancelButton.backgroundColor)
            }
            onClick={() => proceed(false)}
            disabled={false}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}

CustomDialog.propTypes = {
  show: PropTypes.bool,
  proceed: PropTypes.func,
  confirmation: PropTypes.string,
  options: PropTypes.object,
}

export default confirmable(CustomDialog)
